import * as lvFlandersStartschermChatNgUi from '../dist/@lvflanders/startscherm-chat-ng-ui';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].startscherm == null) window['lvflanders'].startscherm = <any>{};
if (window['lvflanders'].startscherm.chat == null) window['lvflanders'].startscherm.chat = <any>{};
if (window['lvflanders'].startscherm.chat.ng == null) window['lvflanders'].startscherm.chat.ng = <any>{};

window['lvflanders'].startscherm.chat.ng.ui = lvFlandersStartschermChatNgUi;

export { lvFlandersStartschermChatNgUi };